import {Component} from '@angular/core';
import {InfoModalComponent} from "../../../views/modal/info_modal.component";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {SupportService} from "../support.service";

@Component({
	templateUrl: './check_for_divly.component.html'
})
export class CheckForDivlyModalComponent extends InfoModalComponent {
	title: string = 'Проверка сайтов на флаг Divly';
	domains: string = '';
	sites: any[] = [];
	alertMessage = '';
	inProgress: boolean = false;

	constructor(public activeModal: NgbActiveModal, public supportService: SupportService) {
		super(activeModal);
	}

	async checkIt() {
		this.alertMessage = '';
		this.sites = [];

		if(this.domains.length < 4) {
			this.alertMessage = 'Message is empty!';

			return;
		}

		let domains = this.domains.split('\n')
			.map(function (r) {
				return r.trim();
			})
			.filter(function (r) {
				return r;
			});

		let r = new RegExp('^(http\:\/\/|https\:\/\/)?([a-z0-9][a-z0-9\-]*\.)+[a-z0-9][a-z0-9\-\/]*$', 'i');
		let isInvalidList = domains.some(site => {
			if(site.match(r) == null) {
				this.alertMessage = `"${site}" is invalid site url`;
				return true;
			}
			return false;
		});

		
		if (!isInvalidList) {
			this.inProgress = true;
			let data = await this.supportService.checkForDivly(domains).toPromise();
			this.sites = data.sites;
			this.inProgress = false;
		}		
	}
	
	ok() {
		this.close();
	}
}
